/**
 * Generate, but not execute, batches of requests to list resources by IDs to avoid API server request length limitations.

 * Certain "list" requests to our APIs (e.g., list subscriptions within the Operations Service) accept comma-separated lists
 * of IDs so that we can send a single HTTP request to list n resources by ID instead of n requests.
 * However, many web servers have limits for the length of HTTP requests they receive and can fail the request if it's too long.
 * For example, our local nginx fails with HTTP 414 Request URI Too Large in such cases.
 */
export const batchBulkListQueryByIDs = (allIDs, listFn, idsPerBatch = 100) => {
    const promises = [];
    for (let i = 0; i < allIDs.length; i += idsPerBatch) {
        const batchIDs = allIDs.slice(i, i + idsPerBatch);
        promises.push(listFn(batchIDs));
    }
    return promises;
};
//# sourceMappingURL=batch-bulk-list-query-by-ids.js.map